import { Table  } from 'reactstrap'
import StatsTable from './StatsTable'
import ActionsTable from './ActionsTable'

export default function SchemaReport(props) {
  console.log('SchemaReport rendered: ', props)
  const { schema } = props

  return (
    <Table bordered size="sm" style={{ width: 'auto' }}>
      <thead>
        <tr><th colSpan={2} style={{ textAlign: 'left' }}>{schema.schema}</th></tr>
      </thead>
      <tbody>
        <tr>
          <td>
            <StatsTable statisticHistory={schema.statisticHistory} />
          </td>
          <td>
            <ActionsTable actionHistory={schema.actionHistory} />
          </td>
        </tr>
      </tbody>
    </Table>
  )
}
